module.exports = __webpack_public_path__ + "media/images/icare-logo-cc708d0a798b7b30f0b499ed26ed5fbc.webp";